import { Component, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProspectSchema, SchemaService } from '@lsq-frontend/remote-services/ar-app';
import { ModalService } from '@lsq-frontend/common-ui';
import { DrApplicationService } from '../../../service/dr-application-service';

@Component({
    selector: 'add-document-list-modal',
    templateUrl: './add-document-list-modal.component.html',
    styleUrls: ['./add-document-list-modal.component.scss']
})
export class AddDocumentListModal {
    public formGroup: FormGroup;
    public documentListOptions: { label: string; value: ProspectSchema }[] = [];
    public documentTitles: String[] = [];
    public selectListDisabled: boolean = true;
    public schemaType: string;

    constructor(private _modalService: ModalService, private _arService: DrApplicationService) {
        this.formGroup = this._modalService.modal.data.formGroup;
        this.schemaType = this._modalService.modal.data.schemaType;
    }

    public async ngOnInit() {
        const getProspectSchemaResponse = this._modalService.modal.data.schema;
        const prospectSchemas = await getProspectSchemaResponse.toPromise();
        this.loadDocumentListOptions(prospectSchemas);
    }

    private loadDocumentListOptions(prospectSchemas: ProspectSchema[]): void {
        var listOptions = [];
        for (const schema of prospectSchemas) {
            var listOption = {
                label: schema.title,
                value: schema
            };
            listOptions.push(listOption);
        }
        this.documentListOptions = listOptions;
        this.selectListDisabled = false;
    }

    public handleDocumentListChange(schema: ProspectSchema) {
        var documentsStage = schema.stageSchemas.find(
            (s) => s.id === this._arService.getDocumentsStageDefaultID()
        );
        var fields = documentsStage.fieldSchemas;
        var fieldLabels = [];
        for (const field of fields) {
            fieldLabels.push(field.label);
        }
        this.documentTitles = fieldLabels;
    }
}
